import { LoanProductCategory } from '@ilg-totallymoney/types'

function getCategoryByCategoryId<T extends { id: string }>(
    categories: T[],
    categoryId: LoanProductCategory
) {
    return categories?.find(category => category.id === categoryId)
}

export default getCategoryByCategoryId
